'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

require('react-select/dist/react-select.css');

var _StyleDef = require('./StyleDef');

var _StyleDef2 = _interopRequireDefault(_StyleDef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import './upload-doc.css'


/*
    Component: UploadDocComponent (Original Author: Akshay Tak)

    Usage: Shows details of the module for which you want to upload documents and gives you container to upload documents in different categories.

    Functions: 
    [1]
    errorWhileUpload(string:errorType, string/number:error) 
        - sends the error type and error if there is any while selecting file for upload
    [2]
    onFileSubmit(object: fileObj, string: category)
        - gives the file object which contains the files details which user has selected to upload
        - dispactes action.onFileSubmit with files to be uploaded and category in which it has to be uploaded 
*/

var UploadDocComponent = function (_React$Component) {
  _inherits(UploadDocComponent, _React$Component);

  function UploadDocComponent(props) {
    _classCallCheck(this, UploadDocComponent);

    var _this = _possibleConstructorReturn(this, (UploadDocComponent.__proto__ || Object.getPrototypeOf(UploadDocComponent)).call(this, props));

    _this.checkGivenFileType = function (files) {

      var fileType = _this.state.fileType;

      var _loop = function _loop(i) {

        var count = null;
        count = fileType.filter(function (defaultType) {
          return defaultType === files[i].type;
        });

        if (count.length) {
          _this.setState({ fileTypeError: false });
        } else {
          var type = files[i].type.split('/');
          _this.setState({ fileTypeError: true });
          _this.props.errorWhileUpload("fileType", type[1]);
          return {
            v: false
          };
        }
      };

      for (var i = 0; i < files.length; i++) {
        var _ret = _loop(i);

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }

      return true;
    };

    _this.fileSizeCheck = function (files) {

      for (var i = 0; i < files.length; i++) {
        if (files[i].size > 1024 * 1024 * parseInt(_this.state.maxSize, 10)) {
          _this.setState({ fileSizeError: true });
          _this.props.errorWhileUpload("fileSize", _this.state.maxSize);
          return false;
        } else {
          _this.setState({ fileSizeError: false });
        }
      }

      return true;
    };

    _this.onFileSubmit = function (e, dropFlag) {

      if (dropFlag) {

        if (e && e.length) {

          var files = e;
          var fileTypeCheck = _this.state.fileType ? _this.checkGivenFileType(files) : true;
          var fileSizeCheck = _this.fileSizeCheck(files);
          _this.setState({ totalCount: 0 });

          if (fileSizeCheck && fileTypeCheck) {
            _this.setState({ totalCount: files.length });
            _this.props.onFileSubmit(files, _this.state.selectedCategory);
          }
        } else {
          _this.setState({ fileSizeError: true, fileTypeError: true });
          _this.props.errorWhileUpload("Error", 'There is some error in given file.');
        }
      } else {

        e.preventDefault();
        e.stopPropagation();

        var _fileTypeCheck = _this.state.fileType ? _this.checkGivenFileType(e.target.files || e.dataTransfer.files) : true;
        var _fileSizeCheck = _this.fileSizeCheck(e.target.files || e.dataTransfer.files);
        _this.setState({ totalCount: 0 });

        if (e.target.files && e.target.files.length && _fileSizeCheck && _fileTypeCheck) {
          _this.setState({ totalCount: e.target.files.length });
          _this.props.onFileSubmit(e.target.files, _this.state.selectedCategory);
        } else if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length && _fileSizeCheck && _fileTypeCheck) {
          _this.setState({ totalCount: e.dataTransfer.files.length });
          _this.props.onFileSubmit(e.dataTransfer.files, _this.state.selectedCategory);
        }
      }
    };

    _this.showDetails = function () {

      if (_this.state.headerDetails && _this.state.headerDetails.length) {

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            { id: 'dataphi-upload-doc-header-detail-title', className: _this.state.styleDefs.dataphiUploadDocHeaderDetailTitle },
            _this.state.headerDetailsTitle
          ),
          _this.state.headerDetails.map(function (detail, i) {
            return _react2.default.createElement(
              'div',
              { className: 'row', key: i },
              _react2.default.createElement(
                'div',
                { id: 'dataphi-upload-doc-header-details-key' + i, className: 'col-md-6' },
                detail[0]
              ),
              _react2.default.createElement(
                'div',
                { id: 'dataphi-upload-doc-header-details-value' + i, className: 'col-md-6' },
                detail[1]
              )
            );
          })
        );
      }
    };

    _this.showLoader = function () {

      if (_this.state.progressBar && _this.state.totalCount) {

        var progressBar = _this.state.progressBar && _this.state.totalCount !== _this.props.uploadedFileCount ? _react2.default.createElement(
          'div',
          { id: _this.state.showUploadButton ? _this.state.styleDefs.dataphiUploadDocBtnProgressBar : _this.state.styleDefs.dataphiUploadDocProgressBar, className: _this.state.showUploadButton ? _this.state.styleDefs.dataphiUploadDocBtnProgressBar : _this.state.styleDefs.dataphiUploadDocProgressBar },
          _react2.default.createElement(_reactBootstrap.ProgressBar, { id: 'dataphi-upload-doc-progress-bar-bs', active: true, bsStyle: 'success', now: 100 })
        ) : null;

        return progressBar;
      }
    };

    _this.onCategoryChange = function (val) {

      _this.setState({ selectedCategory: val.value });
    };

    _this.loadSelectOptions = function () {

      var options = _this.state.docCategories.map(function (option) {
        return { value: option, label: option, clearableValue: false };
      });

      return options;
    };

    _this.showCategorySelection = function () {

      if (_this.state.docCategories && _this.state.docCategories.length) {

        return _react2.default.createElement(
          'div',
          { id: _this.state.styleDefs.dataphiUploadDocSelectTab, className: _this.state.styleDefs.dataphiUploadDocSelectTab },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'category-select',
            clearable: false,
            placeholder: 'Select Category',
            value: _this.state.selectedCategory,
            options: _this.loadSelectOptions(),
            onChange: function onChange(selectedOption) {
              return _this.onCategoryChange(selectedOption);
            }
          })
        );
      }
    };

    _this.showUploadImage = function () {

      if (_this.state.image) return _react2.default.createElement(
        'div',
        { className: _this.state.styleDefs.dataphiUploadDocUploadImg, id: _this.state.styleDefs.dataphiUploadDocUploadImg },
        _react2.default.createElement('img', { src: _this.state.image, height: '40', width: '40', alt: 'Upload button' })
      );else return _react2.default.createElement(_reactBootstrap.Glyphicon, { className: _this.state.styleDefs.dataphiUploadDocUploadImgDefault, id: _this.state.styleDefs.dataphiUploadDocUploadImgDefault, glyph: 'gglyphicon glyphicon-open' });
    };

    _this.showUploadButton = function (acceptedFormat) {

      if (_this.state.showUploadButton) {

        return _react2.default.createElement(
          'label',
          { htmlFor: _this.state.selectedCategory, id: _this.state.disabled ? _this.state.styleDefs.dataphiUploadDocUploadBtnDisabled : _this.state.styleDefs.dataphiUploadDocUploadBtn, className: _this.state.disabled ? _this.state.styleDefs.dataphiUploadDocUploadBtnDisabled : _this.state.styleDefs.dataphiUploadDocUploadBtn },
          _this.state.uploadButtonText,
          _react2.default.createElement('input', { type: 'file', id: _this.state.selectedCategory, name: 'upload here', onClick: function onClick(e) {
              return e.target.value = '';
            }, className: _this.state.styleDefs.dataphiUploadDocUploadInput, accept: acceptedFormat, onDrop: function onDrop(e) {
              return _this.onFileSubmit(e);
            }, onChange: function onChange(e) {
              return _this.onFileSubmit(e);
            }, disabled: _this.state.disabled, multiple: _this.state.multiple })
        );
      } else {

        return _react2.default.createElement(
          _reactDropzone2.default,
          { accept: acceptedFormat, onDrop: function onDrop(e) {
              return _this.onFileSubmit(e, true);
            }, disabled: _this.state.disabled, multiple: _this.state.multiple,
            id: _this.state.disabled ? _this.state.styleDefs.dataphiUploadDocUploadImgBtnDisabled : _this.state.styleDefs.dataphiUploadDocUploadImgBtn,
            className: _this.state.disabled ? _this.state.styleDefs.dataphiUploadDocUploadImgBtnDisabled : _this.state.styleDefs.dataphiUploadDocUploadImgBtn },
          _this.showUploadImage(),
          _react2.default.createElement(
            'p',
            { className: _this.state.styleDefs.dataphiUploadDocUploadImgUploadBtnText },
            _this.state.uploadButtonText
          )
        );
      }
    };

    _this.showBadge = function () {

      if (_this.state.showBadge && _this.state.totalCount) {
        return _react2.default.createElement(
          'div',
          { className: _this.state.showUploadButton ? _this.state.styleDefs.dataphiUploadDocBtnBadgeBlock : _this.state.styleDefs.dataphiUploadDocBadgeBlock },
          _react2.default.createElement(
            _reactBootstrap.Badge,
            { id: _this.state.styleDefs.dataphiUploadDocBadge, className: _this.state.styleDefs.dataphiUploadDocBadge },
            _this.props.uploadedFileCount + '/' + _this.state.totalCount
          )
        );
      }
    };

    _this.showUploadZone = function () {

      var acceptedFormat = _this.state.fileType ? _this.state.fileType : "audio/*, video/*, image/*, application/pdf";

      acceptedFormat = acceptedFormat.toString();

      var error = _this.state.showError && (_this.state.fileSizeError || _this.state.fileTypeError) ? _react2.default.createElement(
        'div',
        { id: _this.state.styleDefs.dataphiUploadDocError, className: _this.state.styleDefs.dataphiUploadDocError },
        _this.state.errorText
      ) : null;

      return _react2.default.createElement(
        'div',
        { id: _this.state.styleDefs.dataphiUploadDocUploadBlock, className: _this.state.styleDefs.dataphiUploadDocUploadBlock },
        _this.showCategorySelection(),
        _react2.default.createElement(
          'label',
          { id: _this.state.docCategories && _this.state.docCategories.length ? _this.state.styleDefs.dataphiUploadDocLabelWidcat : _this.state.styleDefs.dataphiUploadDocLabel,
            className: _this.state.docCategories && _this.state.docCategories.length ? _this.state.styleDefs.dataphiUploadDocLabelWidcat : _this.state.styleDefs.dataphiUploadDocLabel },
          _this.state.selectedCategory
        ),
        _react2.default.createElement('br', null),
        _this.showUploadButton(acceptedFormat),
        _this.showBadge(),
        _this.showLoader(),
        error
      );
    };

    _this.closeModal = function () {

      _this.setState({ show: false });
    };

    _this.showModalFooter = function () {

      if (_this.state.showFooterCloseBtn) {

        return _react2.default.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          _react2.default.createElement(
            _reactBootstrap.Button,
            { onClick: function onClick() {
                return _this.closeModal();
              } },
            'Close'
          )
        );
      }
    };

    _this.showModal = function () {

      var modal = _this.state.modal ? _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          show: _this.state.show,
          keyboard: false,
          onHide: function onHide() {
            return _this.closeModal();
          },
          dialogClassName: _this.state.styleDefs.dataphiUploadDocUploadBlockModal
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          { closeButton: true },
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            { id: 'contained-modal-title' },
            _this.state.title
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            { id: _this.state.styleDefs.dataphiUploadDocHeaderDetails, className: _this.state.styleDefs.dataphiUploadDocHeaderDetails },
            _this.showDetails()
          ),
          _this.showUploadZone()
        ),
        _this.showModalFooter()
      ) : _react2.default.createElement(
        'div',
        { className: _this.state.styleDefs.dataphiUploadDocUploadBlockContent },
        _react2.default.createElement(
          'h3',
          { id: 'dataphi-upload-doc-title', className: _this.state.styleDefs.dataphiUploadDocTitle },
          _this.state.title
        ),
        _react2.default.createElement(
          'div',
          { id: _this.state.styleDefs.dataphiUploadDocheaderDetails, className: _this.state.styleDefs.dataphiUploadDocheaderDetails },
          _this.showDetails()
        ),
        _this.showUploadZone()
      );

      return modal;
    };

    _this.state = {
      modal: props.modal,
      docCategories: props.docCategories,
      fileType: props.fileType,
      multiple: props.multiple,
      maxSize: props.maxSize,
      disabled: props.disabled,
      headerDetails: props.headerDetails,
      headerDetailsTitle: props.headerDetailsTitle,
      progressBar: props.progressBar,
      show: props.show,
      showFooterCloseBtn: props.footerCloseButton,
      title: props.title,
      showError: props.showError,
      showUploadButton: props.showUploadButton,
      uploadButtonText: props.uploadButtonText,
      image: props.image,
      selectedCategory: props.selectedCategory,
      fileSizeError: false,
      fileTypeError: false,
      errorText: props.errorText,
      totalCount: null,
      uploadedFileCount: props.uploadedFileCount,
      showBadge: props.showBadge,
      styleDefs: props.styleDefs
    };
    return _this;
  }

  _createClass(UploadDocComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {

      var styleDefs = Object.assign({}, _StyleDef2.default, this.props.styleDefs);
      this.setState({ styleDefs: styleDefs });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      var newProps = Object.assign({}, nextProps);
      newProps.styleDefs = this.state.styleDefs;

      if (this.state !== newProps) this.setState(newProps);
    }

    //audio, video, pdf, application 

  }, {
    key: 'render',
    value: function render() {

      return this.showModal();
    }
  }]);

  return UploadDocComponent;
}(_react2.default.Component);

/*
    Required props:
        -loginSuccess
            {bool}: indicates transition to /dashboard
        -loginFailure
            {string}: indicated no transition and error message to be displayed
        -submitLogin
            {function}: handles login with username and password params
*/

exports.default = UploadDocComponent;


UploadDocComponent.propTypes = {
  modal: _propTypes2.default.bool,
  docCategories: _propTypes2.default.arrayOf(_propTypes2.default.string),
  fileType: _propTypes2.default.arrayOf(_propTypes2.default.string),
  multiple: _propTypes2.default.bool,
  uploadedFileCount: _propTypes2.default.number.isRequired,
  maxSize: _propTypes2.default.number,
  disabled: _propTypes2.default.bool,
  headerDetails: _propTypes2.default.arrayOf(_propTypes2.default.array),
  headerDetailsTitle: _propTypes2.default.string,
  progressBar: _propTypes2.default.bool,
  show: _propTypes2.default.bool,
  showFooterCloseBtn: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  showError: _propTypes2.default.bool,
  showUploadButton: _propTypes2.default.bool,
  image: _propTypes2.default.string,
  uploadButtonText: _propTypes2.default.string,
  onFileSubmit: _propTypes2.default.func.isRequired,
  errorWhileUpload: _propTypes2.default.func.isRequired,
  selectedCategory: _propTypes2.default.string,
  errorText: _propTypes2.default.string,
  showBadge: _propTypes2.default.bool,
  styleDefs: _propTypes2.default.object
};

UploadDocComponent.defaultProps = {
  modal: false,
  docCategories: null,
  fileType: null,
  multiple: true,
  maxSize: 4,
  disabled: false,
  headerDetails: null,
  headerDetailsTitle: null,
  progressBar: true,
  show: true,
  showFooterCloseBtn: false,
  title: "Upload Documents",
  showError: true,
  showUploadButton: false,
  image: null,
  uploadButtonText: "Select Files",
  selectedCategory: "Click below to upload",
  uploadedFileCount: 0,
  errorText: "Error in files selected for upload",
  showBadge: true,
  styleDefs: {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dataphi-react-components/dist/Containers/DataphiUploadDocContainer/Component/UploadDocComponent.js
// module id = 1912
// module chunks = 0